import {useStore, handleSimulationValidation, getPrimaryText} from "../hooks/store";
import {BlocksPopup} from "./BlocksPopup";
import {useState} from "@wordpress/element";

export const SimulationTeaser = () => {

    const simulation = useStore((state) => state.simulation);
    const context = useStore((state) => state.context);
    const environment = useStore((state) => state.environment);

    const [ isOpen, setOpen ] = useState(false);
    const openModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    const Psawidsimufin = window.Psawidsimufin;
    const Instance = Psawidsimufin.new({
        'selector': '#widget'
    });

    const customizeFinancialSimulation = (e) => {

        Instance.render({
            context: context,
            environment: environment,
            outputFn: (output) => handleSimulationValidation(output)
        });
    }

    return (
        <>
            <div className={"voFinancialSimulationContainer"}>
                <div className={"voFinancialSimulationRow voFinancialSimulationPrice"}>
                    <div className={"voFinancialSimulationTitle"}>
                        Financement
                    </div>
                    <div className={"voFinancialSimulationValue"}>
                        <div className={"voFinancialSimulationMoreInfoIcon"} onClick={ openModal }>i</div>
                        {Math.round(simulation.teaser.data.regularPayment.amountInclTax)} €/Mois
                    </div>
                </div>
                <div className={"voFinancialSimulationRow voFinancialSimulationAlignRight"}>
                    {getPrimaryText()}
                </div>
                <div className={"voFinancialSimulationRow  voFinancialSimulationAlignRight"}>
                    {simulation.teaser.legalNotice.text}
                </div>
                <div className={"voFinancialSimulationRow voFinancialSimulationCustomize"}>
                    <span className={"voCustomizeFinancialSimulation"} onClick={customizeFinancialSimulation}>
                        {simulation.teaser.callToAction.text}
                    </span>
                </div>
            </div>
            <div id={"widget"}></div>
            <BlocksPopup open={isOpen} closeCallback={closeModal} />
        </>
    )
}